import * as store from "./modules/store";
import * as dealer from "./modules/dealer";
import * as common from "./modules/common";
import * as visit from "./modules/visit";
import * as pca from "./modules/pca";
import * as user from "./modules/user";
import * as target from "./modules/target";

export default {
  store,
  dealer,
  common,
  visit,
  pca,
  user,
  target,
};
